import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { DateFormatConfig } from '@app/utilities/date-format-config';
import { fragQuery, User } from '@models';

@Component({
  selector: 'data-interval-selector',
  templateUrl: './data-interval-selection.component.html',
  styleUrls: ['./data-interval-selection.component.scss']
})
export class DataIntervalSelectionComponent {

  constructor(
    public dialogue: MatDialog,
    private user: User,
    protected readonly dialog: DialogService,
    private readonly dateFormate: DateFormatConfig
  ) { }

  @Input()
  get checked(): boolean {
    return this._checked;
  }
  set checked(value: boolean) {
    this._checked = value;
  }

  @Input()
  get interval(): fragQuery.timeline.sieveSizesAtPercents.Interval {
    return this._interval;
  }
  set interval(value: fragQuery.timeline.sieveSizesAtPercents.Interval) {
    this._interval = value;
  }

  @Output() selected: EventEmitter<boolean> = new EventEmitter<boolean>();

  public _checked: boolean = false;
  public _interval: fragQuery.timeline.sieveSizesAtPercents.Interval;
  @ViewChild('fullimgtemplate', { static: false })
  fullimgtemplate!: TemplateRef<any>;

  public readonly dateTimeFormat = this.dateFormate.getFormat()

  showFullImg(src?: string) {
    this.dialogue.open(this.fullimgtemplate, {
      width: '100%',
    });
  }

  onCheck() {
    this._checked = !this._checked;
    this.selected.emit(this._checked)
  }

  closeFullImg() {

  }
}
